import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewMode", "editMode", "editButton", "cancelButton"]

  connect() {
    this.showViewMode()
  }

  edit(event) {
    event.preventDefault()
    this.showEditMode()
  }

  cancel(event) {
    event.preventDefault()
    this.showViewMode()
  }

  showViewMode() {
    this.viewModeTarget.classList.remove("hidden")
    this.editModeTarget.classList.add("hidden")
  }

  showEditMode() {
    this.viewModeTarget.classList.add("hidden")
    this.editModeTarget.classList.remove("hidden")
  }
}
